import { render, staticRenderFns } from "./AboutBeliefs.vue?vue&type=template&id=778d9a63&"
import script from "./AboutBeliefs.vue?vue&type=script&lang=js&"
export * from "./AboutBeliefs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports